import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getOrderDetailById, delOrder } from '@/api/module/user';
import { getGroupInfoList, getExcludeInfoList, plusGroups, minusGroups } from '@/api/module/index';
import { Toast, Dialog } from "vant";
import HtmlPanel from "@/components/HtmlPanel";
export default {
  name: "index",
  components: {
    HtmlPanel: HtmlPanel
  },
  data: function data() {
    return {
      singleShowMoney: true,
      showMoney: window.g.VUE_APP_SHOW_MONEY,
      VUE_APP_HIDE_MONEY_COMPANYIDS: window.g.VUE_APP_HIDE_MONEY_COMPANYIDS,
      user: {},
      //登录用户信息
      active: 0,
      hospitalName: window.g.VUE_APP_HOSPITALNAME,
      hospitalPhone: window.g.VUE_APP_PHONE,
      hospitalAddress: window.g.VUE_APP_ADDRESS,
      additionalAutoadd: window.g.VUE_APP_ADDITIONAL_AUTOADD,
      //预约关联项目材料费附加费是否自动关联
      orderAddItem: window.g.VUE_APP_ORDER_ADDITEM,
      hospitalMapPicSrc: window.g.VUE_APP_SUB_DIR + "/hospital/map.png",
      datas: {
        userInfo: {},
        groups: []
      },
      showAdd: false,
      //增加项目
      showDel: false,
      //删除项目
      showAddList: false,
      //已选加做项目
      deptArr: [],
      //部门列表
      data: [],
      groups: [],
      //组合列表
      checkDeptStr: '',
      disableGroup: [],
      //组合，默认显示，默认禁止
      result: [],
      //已经选择了的项目ID
      delresult: [],
      //需要删除的项目ID
      excludeInfoList: [],
      //组合排斥关联
      checkedGroups: [],
      //加做项目已经选择了组合对象
      total: 0,
      //加做项目合计金额
      getPageUrl: window.g.VUE_APP_SUB_DIR + '/HtmlPanels/notice.html',
      settlement: '',
      //支付状态
      status: '',
      //预约状态
      orderno: '' //回写订单号

    };
  },
  created: function created() {
    //套餐ID
    var bookedno = this.$route.query.bookedno;
    this.settlement = this.$route.query.settlement;
    this.getDetail(bookedno);
    this.getGroups();
    this.getExcludes();
    this.user = JSON.parse(localStorage.getItem("loginuser"));
    this.setShowMoney();
  },
  filters: {
    typeFilter: function typeFilter(value) {
      if (value == '1') {
        return '套餐';
      } else if (value == '2') {
        return '自选';
      }
    },
    filterSettlement: function filterSettlement(value) {
      switch (value) {
        case '0':
          {
            return '未付款';
            break;
          }

        case '1':
          {
            return '已付款';
            break;
          }

        default:
          {
            return '';
          }
      }
    }
  },
  methods: {
    //计算showMoney的值
    setShowMoney: function setShowMoney() {
      if (this.showMoney) {
        if (Array.isArray(this.VUE_APP_HIDE_MONEY_COMPANYIDS)) {
          if (this.VUE_APP_HIDE_MONEY_COMPANYIDS.includes(this.$route.query.companyid.substring(0, 4))) {
            this.singleShowMoney = false;
          }
        }
      }
    },
    //增加项目
    plusItem: function plusItem() {
      this.showAdd = true;
    },
    //删除项目
    minusItem: function minusItem() {
      this.delresult = [];
      this.showDel = true;
    },
    //取消预约
    del: function del() {
      var _this = this;

      Dialog.confirm({
        title: '提示',
        message: '确认取消预约吗？'
      }).then(function () {
        var bookedno = _this.$route.query.bookedno;
        var param = {
          bookedno: bookedno
        };
        delOrder(param).then(function (res) {
          if (res.code == 200) {
            if (res.data == 0) {
              Toast.fail(res.msg);
            } else {
              _this.$router.push({
                name: 'orders'
              });
            }
          }
        });
      });
    },
    //复制成功
    onCopy: function onCopy() {
      Toast.success('复制成功');
    },
    //复制失败
    onError: function onError() {
      Toast.success('复制失败');
    },
    //根据套餐ID查询详情
    getDetail: function getDetail(bookedno) {
      var _this2 = this;

      var param = {
        bookedno: bookedno
      };
      getOrderDetailById(param).then(function (res) {
        if (res.code == 200) {
          _this2.datas = res.data;
        }
      });
    },
    //获取当前时间
    getNow: function getNow() {
      var char = "-";
      var nowDate = new Date();
      var day = nowDate.getDate();
      var month = nowDate.getMonth() + 1; //注意月份需要+1

      var year = nowDate.getFullYear(); //补全0，并拼接

      return year + char + this.completeDate(month) + char + this.completeDate(day);
    },
    //补全0
    completeDate: function completeDate(value) {
      return value < 10 ? "0" + value : value;
    },
    //返回短日期格式yyyy-MM-dd
    bookeddateFilter: function bookeddateFilter(value) {
      if (value != undefined) {
        return value.substring(0, 10);
      }

      return value;
    },
    //获取所有项目
    getGroups: function getGroups() {
      var _this3 = this;

      var param = {};
      getGroupInfoList(param).then(function (res) {
        if (res.code == 200) {
          //根据科室进行分类
          _this3.data = res.data;
          res.data.forEach(function (item) {
            if (!_this3.deptArr.includes(item.departmentName) && item.departmentName != undefined) {
              _this3.deptArr.push(item.departmentName);
            }
          });
          res.data.forEach(function (item) {
            if (item.departmentName == _this3.deptArr[0]) {
              console.log(item.departmentName);

              _this3.groups.push(item);

              _this3.checkDept(item.departmentName);
            }
          });
        }
      });
    },
    //切换科室
    checkDept: function checkDept(name) {
      var _this4 = this;

      this.groups = [];
      this.checkDeptStr = name; //根据科室名称过滤组合

      this.data.forEach(function (item) {
        if (item.departmentName == name) {
          _this4.groups.push(item);

          _this4.checkSex();
        }
      });
    },
    //加做项目，选择项目
    checkGroup: function checkGroup(groupId, groupName) {
      var _this5 = this;

      if (/(?=.*?液基)(?=.*?TCT)/g.test(groupName) || groupName.indexOf("HPV") != -1 || groupName.indexOf("妇科") != -1 || groupName.indexOf("阴道分泌物") != -1) {
        //判断是选择还是取消
        if (this.result.includes(groupId)) {
          Dialog.confirm({
            title: '温馨提示',
            message: '没有性生活史禁止检查'
          }).then(function () {
            // on confirm
            _this5.checkGroupAfter(groupId, groupName);
          }).catch(function () {
            // on cancel
            _this5.result.splice(_this5.result.findIndex(function (n) {
              return n === groupId;
            }), 1);
          });
        } else {
          this.checkGroupAfter(groupId, groupName);
        }
      } else {
        this.checkGroupAfter(groupId, groupName);
      }
    },
    //加做项目，选择项目执行后动作
    checkGroupAfter: function checkGroupAfter(groupId, groupName) {
      var _this6 = this;

      //排斥项目
      //1、this.datas.groups //套餐项目
      //console.log(this.excludeInfoList)
      //根据组合ID查询该组合的排斥项目
      var exclude = this.excludeInfoList.filter(function (item) {
        return item.groupId == groupId;
      }).map(function (jtem) {
        return jtem.excludeGroupList;
      })[0];
      exclude.forEach(function (i) {
        _this6.datas.groups.forEach(function (j) {
          if (i.relationGroupId == j.groupId) {
            Dialog.alert({
              title: '提示',
              message: '不能添加，该项目【' + groupName + '】与已选套餐项目【' + j.groupName + '】互相排斥'
            }).then(function () {// on close
            });

            _this6.result.splice(_this6.result.findIndex(function (n) {
              return n === groupId;
            }), 1);

            return;
          }
        });
      }); //2、this.result //选择的加做项目

      var resultGroups = [];
      this.result.forEach(function (item) {
        _this6.data.forEach(function (jtem) {
          if (item == jtem.groupId) {
            resultGroups.push(jtem);
          }
        });
      });
      exclude.forEach(function (i) {
        resultGroups.forEach(function (j) {
          if (i.relationGroupId == j.groupId) {
            Dialog.alert({
              title: '提示',
              message: '不能添加，该项目【' + groupName + '】与已选加做项目【' + j.groupName + '】互相排斥'
            }).then(function () {// on close
            });

            _this6.result.splice(_this6.result.findIndex(function (n) {
              return n === groupId;
            }), 1);

            return;
          }
        });
      }); //2、关联项目
      //根据组合ID查询该组合的关联项目
      //判断是选择还是取消
      //选择

      var relationAdd = '';
      var depend = this.excludeInfoList.filter(function (item) {
        return item.groupId == groupId;
      }).map(function (jtem) {
        return jtem.dependGroupList;
      })[0];

      if (this.result.includes(groupId)) {
        depend.forEach(function (item) {
          if (!_this6.result.includes(item.relationGroupId)) {
            var packageRepeat = _this6.dates.filter(function (jtem) {
              //判断材料费附加费是否需要关联自动添加
              if (_this6.additionalAutoadd) {
                return jtem.groupid == item.groupId;
              } else {
                return jtem.groupid == item.groupId && jtem.itemType != '8' && jtem.itemType != '9';
              }
            });

            if (packageRepeat.length <= 0) {
              relationAdd += item.relationGroupName + ',';

              _this6.result.push(item.relationGroupId);
            }
          }
        });
        Dialog.alert({
          title: '提示',
          message: '该项目【' + groupName + '】有关联必选项目【' + relationAdd + '】，已为您添加'
        }).then(function () {// on close
        });
      } else {
        //取消，提示将关联的项目也取消
        var relationDel = [];
        var relationDelName = [];
        depend.forEach(function (item) {
          if (_this6.result.includes(item.relationGroupId)) {
            relationDel.push(item.relationGroupId);
          }
        });

        if (relationDel.length > 0) {
          this.datas.forEach(function (item) {
            relationDel.forEach(function (jtem) {
              if (item.groupId == jtem) {
                relationDelName.push(item.groupName);
              }
            });
          });
          Dialog.confirm({
            title: '提示',
            message: '请注意，该项目【' + groupName + '】有关联必选项目【' + relationDelName.join(",") + '】，是否需要取消关联项目？'
          }).then(function () {
            // on confirm
            relationDel.forEach(function (item) {
              _this6.result.splice(_this6.result.findIndex(function (n) {
                return n === item;
              }), 1);
            });
          }).catch(function () {// on cancel
          });
        }
      }
    },
    //将不适用性别的组合禁用掉
    checkSex: function checkSex() {
      var _this7 = this;

      this.disableGroup = []; //判断性别是否适用

      var userSex = this.user.sexid;

      if (userSex == "0") {
        //女
        //过滤男性组合
        this.groups.forEach(function (item) {
          if (item.sexId == '1' && item.sexId != '0') {
            _this7.disableGroup.push(item.groupId);
          }
        });
      } else if (userSex == "1") {
        //男
        //过滤女性组合
        this.groups.forEach(function (item) {
          if (item.sexId == '2' && item.sexId != '0') {
            _this7.disableGroup.push(item.groupId);
          }
        });
      } //将套餐内包含的项目禁用掉


      this.groups.forEach(function (item) {
        _this7.datas.groups.forEach(function (jtem) {
          if (item.groupId == jtem.groupid) {
            _this7.disableGroup.push(item.groupId);
          }
        });
      });
    },
    //获取关联排斥项目
    getExcludes: function getExcludes() {
      var _this8 = this;

      getExcludeInfoList().then(function (res) {
        if (res.code == 200) {
          _this8.excludeInfoList = res.data;
        }
      });
    },
    //清空已选项目
    clearGroups: function clearGroups() {
      var _this9 = this;

      Dialog.confirm({
        title: '提示',
        message: '您确定要清空已选加做项目吗？'
      }).then(function () {
        Toast('已清空已选加做项目');
        _this9.result = [];
        _this9.checkedGroups = [];
      }).catch(function () {// on cancel
      });
    },
    //查看已选加做项目
    showChecked: function showChecked() {
      var _this10 = this;

      if (this.result.length == 0) {
        Dialog.alert({
          title: '提示',
          message: '没有已选项目'
        }).then(function () {// on close
        });
      } else {
        this.showAddList = true; //根据已选ID，遍历出已选的组合对象

        this.checkedGroups = [];
        this.result.forEach(function (item) {
          _this10.data.forEach(function (jtem) {
            if (item == jtem.groupId) {
              _this10.checkedGroups.push(jtem);
            }
          });
        });
        var money = 0;
        this.checkedGroups.forEach(function (item) {
          money = money + item.actualPrice;
        });
        this.total = money * 100;
      }
    },
    //提交加做项目
    submitPlus: function submitPlus() {
      var _this11 = this;

      Dialog.confirm({
        title: '提示',
        message: '您确定要加做选择的项目吗'
      }).then(function () {
        var param = {
          bookedno: _this11.$route.query.bookedno,
          groupIdList: _this11.result,
          checkdate: _this11.datas.checkdate
        };
        plusGroups(param).then(function (res) {
          if (res.code == 200) {
            if (res.data == '0') {
              Dialog.alert({
                title: '温馨提示',
                message: res.msg
              }).then(function () {});
            } else {
              Toast.success('操作成功');
              location.reload();
            }
          }
        });
      }).catch(function () {// on cancel
      });
    },
    //确认删除选中项目
    submitDel: function submitDel() {
      var _this12 = this;

      if (this.delresult.length == 0) {
        Dialog.alert({
          title: '提示',
          message: '没有选中需要删除的项目'
        }).then(function () {// on close
        });
      } else {
        Dialog.confirm({
          title: '提示',
          message: '您确定要删除选中的项目吗？'
        }).then(function () {
          _this12.showDel = false;
          var param = {
            bookedno: _this12.$route.query.bookedno,
            groupIdList: _this12.delresult,
            checkdate: _this12.datas.checkdate
          };
          minusGroups(param).then(function (res) {
            if (res.code == 200) {
              Toast.success('操作成功');
              location.reload();
            }
          });
        }).catch(function () {// on cancel
        });
      }
    }
  }
};